<template>
  <svg class="plan-map" :viewBox="bounds.join(' ')" preserveAspectRatio="xMidYMid meet" role="group" :aria-label="$t('building.plan.map')" tabindex="0" @keydown="$emit('navigate', $event)">
    <defs><clipPath id="plan-region-clip"><rect :x="bounds[0]" :y="bounds[1]" :width="bounds[2]" :height="bounds[3]" /></clipPath></defs>
    <g clip-path="url(#plan-region-clip)">
      <g class="plan-background" v-html="background" />
      <PlanDesk v-for="entry in entries" :key="entry.workplace.key" :geometry="entry.workplace.geometry" :color="entry.color" :label="entry.label"
        :selected="entry.selected" :dimmed="entry.dimmed" @activate="$emit('activate', entry.workplace, $event)"
        @hover="$emit('hover', entry.workplace, $event)" @unhover="$emit('unhover', entry.workplace.key, $event)" />
      <g class="plan-shared-overlays" aria-hidden="true">
        <g v-for="entry in entries" :key="'overlay-' + entry.workplace.key" :class="{ 'plan-overlay--dimmed': entry.dimmed }">
          <g v-if="entry.workplace.active.length > 1" class="plan-shared">
            <circle :cx="entry.workplace.geometry.x + entry.workplace.geometry.width - 2" :cy="entry.workplace.geometry.y + 2" r="4.5" fill="#343b3d" />
            <text :x="entry.workplace.geometry.x + entry.workplace.geometry.width - 2" :y="entry.workplace.geometry.y + 4" text-anchor="middle" fill="white" font-size="6" font-family="Arial">{{ entry.workplace.active.length }}</text>
          </g>
        </g>
      </g>
      <g class="plan-status-overlays" aria-hidden="true">
        <g v-for="entry in entries" :key="'markers-' + entry.workplace.key" :class="{ 'plan-overlay--dimmed': entry.dimmed }">
          <circle v-if="admin && entry.workplace.photoPending" class="plan-marker" :cx="entry.workplace.geometry.photoMarker.x" :cy="entry.workplace.geometry.photoMarker.y" r="3" fill="#8250ff" />
          <circle v-if="admin && entry.workplace.bioPending" class="plan-marker" :cx="entry.workplace.geometry.bioMarker.x" :cy="entry.workplace.geometry.bioMarker.y" r="3" fill="#50a3ff" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import PlanDesk from './PlanDesk';
export default {
  name: 'PlanMap',
  components: { PlanDesk },
  props: { entries: { type: Array, required: true }, bounds: { type: Array, required: true }, background: String, admin: Boolean }
};
</script>

<style scoped>
.plan-map { position: absolute; inset: 0; display: block; width: 100%; height: 100%; outline: none; touch-action: none; transform-box: border-box; }
.plan-background, .plan-shared-overlays, .plan-status-overlays { pointer-events: none; }
.plan-overlay--dimmed { opacity: 0.18; }
</style>
